'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var charToByte = exports.charToByte = function charToByte(c) {
  return c.charCodeAt(0) < 128 ? c.charCodeAt(0) // This is english alphabet
  : c.charCodeAt(0) - 0x0e01 /* Utf8 ก */ + 161; /* Window-874 ก*/
};
var toByteArray = exports.toByteArray = function toByteArray(s) {
  return s.split('').map(function (c) {
    return charToByte(c);
  });
};
var utf8ToAnsi = exports.utf8ToAnsi = function utf8ToAnsi(s) {
  return toByteArray(s).map(function (c) {
    return String.fromCharCode(c);
  }).reduce(function (converted, c) {
    return converted + c;
  });
};